import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcRequirementStatus } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcRequirementStatusList,

    LoadCcRequirementStatuses,
    DeleteCcRequirementStatus,
    DragnDropCcRequirementStatus,

    setCcRequirementStatusList,
    setCcRequirementStatusIds,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    DeleteRow,
    DragnDrop,
} from "client/components"

import Columns from "./columns"
import Edit from "./edit"

const Status = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const statusList = useSelector((state: StoreType) => state.ccRequirementStatus.statusList)
    const statusIds = useSelector((state: StoreType) => state.ccRequirementStatus.statusIds)
    const reloadList = useSelector((state: StoreType) => state.ccRequirementStatus.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultRequirementsStatusAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        setLoadState(PENDING)
        LoadCcRequirementStatuses(userData.accountId, project.id)
        .then((res) => {
            dispatch(setCcRequirementStatusList(res.statusList))
            dispatch(setCcRequirementStatusIds(res.statusIds))
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, project, defaultRequirementsStatusAssigned])

    const onDelete: DeleteRow = (status: CcRequirementStatus, callback) => {
        DeleteCcRequirementStatus(status.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const statusListCopy: CcRequirementStatusList = statusList ? deepCopy(statusList) : {}
                delete statusListCopy[status.id]
                dispatch(setCcRequirementStatusList(statusListCopy))
                dispatch(setCcRequirementStatusIds(statusIds.filter((id) => id !== status.id)))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setCcRequirementStatusIds(dataIds))
        setLoadState(PENDING)
        DragnDropCcRequirementStatus(dataIds, statusList).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={statusList}
                dataIds={statusIds}
                rowSize="sm"
                showPagination={false}
                onDelete={onDelete}
                onDragnDrop={onDragnDrop}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addStatus",
                            content: <Edit statusId={0} editAccess={editAccess} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default Status
